import PodToolbar from '@/components/PodToolbar';
import { SORT_BY, SortBy } from '@/lib/hooks/useDailyGamesByCriteria';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Button, createComponent, Dropdown, DropdownItem, Flex, For, IconFA, IntrinsicProps, Slot } from 'react-commons';

interface NewGamesByTaxonomyToolbarProps extends IntrinsicProps {
  sortBy: string
  setSortBy: (nextSort: string) => void
}

export default createComponent<NewGamesByTaxonomyToolbarProps>('NewGamesByTaxonomyToolbar', {}, function NewGamesByTaxonomyToolbar ({ className }, props) {
  return (
    <PodToolbar>
      <Flex alignCenter collapseMobile wide>
        <strong className='--padSm1' style={{ whiteSpace: 'nowrap' }}>Sort by:</strong>
        <Dropdown>
          <Slot name='trigger'>
            <Button small>
              <span>{SORT_BY[ props.sortBy ]}</span>&nbsp;
              <IconFA icon={faChevronDown} small />
            </Button>
          </Slot>

          <Slot name='content'>
            {
              For(Object.entries(SORT_BY), ([ sortBy, label ]) => (
                <DropdownItem onClick={() => props.setSortBy(sortBy as SortBy)}>{label}</DropdownItem>
              ))
            }
          </Slot>
        </Dropdown>
      </Flex>
    </PodToolbar>
  );
});
